import { Link } from '@reach/router';
import MainSidebar from 'app/components/Sidebar';
import { FiChevronLeft } from 'react-icons/fi';
export default function BannerSidebar() {
  return (
    <MainSidebar hasBrand={false}>
      <nav className="notebook-sidebar__nav">
        <Link
          to="/banners"
          className="filter-bar__back"
        >
          <div className="card__icon-wrapper">
            <FiChevronLeft />
          </div>
          <span className="filter-bar__back-container">
            <span className="filter-bar__title">Banner informativo</span>
          </span>
        </Link>
      </nav>
    </MainSidebar>
  );
}
